(() => {
  const homepage = document.querySelector('#MainContent[data-template="index"]');

  if (!homepage) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const isDesignMode = Boolean(window.Shopify?.designMode);

  function addAos(element, animation, options = {}) {
    if (!element || element.dataset.aos || element.classList.contains('scroll-trigger')) return;

    const duration = options.duration || 700;
    const delay = options.delay || 0;

    element.dataset.aos = animation;
    element.dataset.aosOffset = String(options.offset ?? 70);
    element.style.setProperty('--vag-motion-duration', `${duration}ms`);
    element.style.setProperty('--vag-motion-delay', `${delay}ms`);
  }

  function annotateHomepageMotion(root = document) {
    const hero = root.querySelector('.custom-slideshow .slideshow__slide:first-child');
    const heroParts = hero
      ? hero.querySelectorAll(
          '.slideshow__caption, .slideshow__heading, .slideshow__description, .slideshow__buttons'
        )
      : [];

    heroParts.forEach((element, index) => {
      addAos(element, 'vag-hero-line', {
        duration: 650,
        delay: 60 + index * 80,
        offset: 0,
      });
    });

    root.querySelectorAll('.icon-benefits-bar__item').forEach((element, index) => {
      addAos(element, 'vag-pop', {
        duration: 550,
        delay: Math.min(index * 60, 180),
        offset: 25,
      });
    });

    root.querySelectorAll('.section-featured-collection').forEach((section) => {
      addAos(section.querySelector('.featured-collection-design__header'), 'vag-lift', {
        duration: 600,
        offset: 50,
      });
    });

    root.querySelectorAll('.section-image-icon-benefits').forEach((section) => {
      addAos(section.querySelector('.image-icon-benefits__media'), 'vag-drift-left', {
        duration: 700,
        offset: 90,
      });
      addAos(section.querySelector('.image-icon-benefits__content'), 'vag-drift-right', {
        duration: 700,
        delay: 60,
        offset: 90,
      });
    });

    root.querySelectorAll('.collector-testimonials').forEach((section) => {
      addAos(section.querySelector('.collector-testimonials__header'), 'vag-lift', {
        duration: 600,
        offset: 55,
      });
      addAos(section.querySelector('.collector-testimonials__viewport'), 'vag-drift-right', {
        duration: 700,
        delay: 50,
        offset: 85,
      });
    });

    root.querySelectorAll('.section-image-product-showcase').forEach((section) => {
      addAos(section.querySelector('.image-product-showcase__header'), 'vag-lift', {
        duration: 600,
        offset: 55,
      });
    });

    document
      .querySelectorAll('.shopify-section--figma-footer-image .figma-footer-image-section__media')
      .forEach((element) => {
        addAos(element, 'vag-footer-rise', {
          duration: 850,
          offset: 20,
        });
      });
  }

  function initializeAos() {
    if (!window.AOS || reducedMotion.matches || isDesignMode) return;

    annotateHomepageMotion(document);
    document.documentElement.classList.add('homepage-motion-ready');

    window.AOS.init({
      once: true,
      mirror: false,
      offset: 70,
      duration: 700,
      easing: 'ease-out-cubic',
      anchorPlacement: 'top-bottom',
      disableMutationObserver: true,
      debounceDelay: 80,
      throttleDelay: 70,
    });

    window.addEventListener('load', () => window.AOS.refresh(), { once: true });
  }

  function initializeLenis() {
    if (!window.Lenis || reducedMotion.matches || !finePointer.matches || isDesignMode) return;

    const lenis = new window.Lenis({
      autoRaf: true,
      smoothWheel: true,
      lerp: 0.14,
      wheelMultiplier: 1,
      anchors: true,
      prevent: (node) =>
        Boolean(
          node?.closest?.(
            '[data-lenis-prevent], dialog, [role="dialog"], .menu-drawer, .cart-drawer, .predictive-search, .quick-add-modal'
          )
        ),
    });

    const syncScrollLock = () => {
      const scrollLocked = Array.from(document.body.classList).some((className) =>
        className.startsWith('overflow-hidden')
      );

      if (scrollLocked) {
        lenis.stop();
      } else {
        lenis.start();
      }
    };

    new MutationObserver(syncScrollLock).observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });

    window.homepageLenis = lenis;
  }

  initializeAos();
  initializeLenis();
})();
